import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./MultipleChoiceProxyVoteItem.module.css";
import GreenCheckmark from "ManagementTeam/Shared/GreenCheckmark";
import MultipleChoiceItem from "ManagementTeam/Shared/MultipleChoiceItem";

/**
 * View component. Shows information about the diamond and their voting status
 */

export function MultipleChoiceProxyVoteItem({
  diamondInfo,
  multipleChoiceItems,
  selected,
  setSelected,
}) {
  const [currentVotes, setCurrentVotes] = useState(selected ? selected : []);

  const handleVotes = (itemPosition) => {
    if (currentVotes.includes(itemPosition)) {
      setCurrentVotes(currentVotes.filter((e) => e !== itemPosition));
    } else {
      setCurrentVotes([...currentVotes, itemPosition]);
    }
  };

  useEffect(() => {
    setSelected(currentVotes);
  }, [currentVotes]);

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        {diamondInfo.checkedIn === true ? (
          <div className={styles.checkmarkContainer}>
            <GreenCheckmark className={styles.checkmark} />
            <div className={styles.checkmarkBackground}></div>
          </div>
        ) : null}

        <img
          src={diamondInfo.photo}
          alt={diamondInfo.firstName}
          className={styles.image}
        />
        <div>
          {diamondInfo.firstName} {diamondInfo.lastName}
        </div>
      </div>

      <div className={styles.votesContainer}>
        {multipleChoiceItems.map((option) => {
          return (
            <div
              className={styles.multipleChoiceItem}
              onClick={() => handleVotes(option.itemPosition)}
            >
              <MultipleChoiceItem
                isSelected={currentVotes.includes(option.itemPosition)}
                itemPosition={option.itemPosition}
                itemTitle={option.itemTitle}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

MultipleChoiceProxyVoteItem.propTypes = {
  // Info for Proxy Vote individual
  diamondInfo: PropTypes.object,

  // Array of the multiple choice items
  multipleChoiceItems: PropTypes.array,

  // Array of options that are selected
  selected: PropTypes.array,

  // Function prop to set selected options
  setSelected: PropTypes.func,
};

MultipleChoiceProxyVoteItem.defaultProps = {
  multipleChoiceItems: [],
  selected: [],
};
